// extracted by mini-css-extract-plugin
export default {"darkGrey":"#73818a","header":"header__1JYoe","countrySelect":"countrySelect__iMNUW","fabButton":"fabButton__28iTp","headerLeft":"headerLeft__14NWe","headerRight":"headerRight__QNdHB","flag-select":"flag-select__2y4_t","flag-options":"flag-options__1-Bvm","currency":"currency__1X4zl","contact":"contact__1GeJ8","basket":"basket__2H8Ff","basketNb":"basketNb__cx8Wb","basketInactive":"basketInactive__1VAxz","previousButton":"previousButton__3zeAA"};
    if(module.hot) {
      // 1788784362158
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  